module.exports = __webpack_public_path__ + "static/media/grid-item-b14.048763e9.png";